export default __webpack_public_path__ + "static/media/back.7519e694.svg";